module.exports = __webpack_public_path__ + "img/data-item1-3.f61fa5f.png";